import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useContext, useMemo } from 'react';
import { usePartialAppSelector } from 'shared/hooks/redux/hooks';
import { TempstepField } from 'console/shared/components/fields';
import { Z3KSettings, Z3KSettingsEditor, } from 'console/device-settings/z3k/provider/types';
import { selectDevice } from 'entities/device/lib';
import { Control } from 'console/shared/components/fields/control';
const min = 0.1;
const max = 10;
export const TempStepField = memo(function TempStepField() {
    const { device_id, save_device_settings } = useContext(Z3KSettings);
    const { deviceSettings } = useContext(Z3KSettingsEditor);
    const tempstep = usePartialAppSelector(selectDevice, device_id)?.tempstep ?? 1;
    const onSetTempStep = useCallback((value) => {
        save_device_settings({ tempstep: value });
    }, []);
    const has_error = useMemo(() => {
        if (deviceSettings) {
            const { tempstep: settings_tempstep = tempstep } = deviceSettings;
            if (settings_tempstep > max || settings_tempstep < min) {
                return `Допустимые значения от ${min} до ${max}`;
            }
        }
        return null;
    }, [min, max, deviceSettings, tempstep]);
    return (_jsx(Control, { label: "\u0428\u0430\u0433 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0442\u0435\u043C\u043F\u0435\u0440\u0430\u0442\u0443\u0440\u044B \u043A\u043D\u043E\u043F\u043A\u0430\u043C\u0438 -/+", help_id: "tempstep", validation_result: has_error, validation_warnings_result: null, value: deviceSettings?.tempstep ?? tempstep, onChange: onSetTempStep, field: (input_props) => (_jsx(TempstepField, { ...input_props, min: min, max: max })) }));
});
